import { Suggestions } from '../types';

const appendSuggestions = (
    toAppend: Suggestions[],
    toPrepend: Suggestions[],
    filterAppend = false,
) => {
    const appendSuggestions = filterAppend
        ? toAppend.filter(([toAppendModifier]) => {
              const toAppendModifierString = JSON.stringify(toAppendModifier);

              return toPrepend.some(
                  ([toPrependModifier]) =>
                      JSON.stringify(toPrependModifier) ===
                      toAppendModifierString,
              );
          })
        : toAppend;

    const combinedSuggestions = appendSuggestions.concat(toPrepend);
    const set = new Set();

    const uniqueSuggestions = combinedSuggestions.filter(([modifier]) => {
        const modifierString = JSON.stringify(modifier);

        return set.has(modifierString)
            ? false
            : set.add(JSON.stringify(modifier));
    });

    return uniqueSuggestions;
};

export default appendSuggestions;
